export var MessageBusTopic;
(function (MessageBusTopic) {
    MessageBusTopic["advancedSearchInitialized"] = "advancedSearch.initialized";
    MessageBusTopic["searchOpen"] = "search.open";
    MessageBusTopic["searchOpenNative"] = "navigation.queryString.search";
    MessageBusTopic["searchClose"] = "search.close";
    MessageBusTopic["oddsFormatChanged"] = "onOddsFormatChanged";
    MessageBusTopic["betslipOddsFormatChanged"] = "betslip.priceFormat.set";
    MessageBusTopic["betslipSelectionsChanged"] = "wh.sports.betslip.headless.selections";
    MessageBusTopic["internalRedirect"] = "internalRoute";
    MessageBusTopic["pageChanged"] = "navigation.pageChanged";
    MessageBusTopic["betslipLegAdd"] = "wh.sports.betslip.adapter.leg.add";
    MessageBusTopic["betslipLegRemove"] = "wh.sports.betslip.adapter.leg.remove";
})(MessageBusTopic || (MessageBusTopic = {}));
export function getMessageBus() {
    var _a;
    return ((_a = window.WH) === null || _a === void 0 ? void 0 : _a.messageBus) || null;
}
//# sourceMappingURL=messageBus.js.map